import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import FieldContainer from "../components/FieldContainer";
import englishCountries from "react-select-country-list";
import frenchCountries from "../data/countries-fr.json";
import Select from "../components/FixedRequiredSelect";
import memoizeOne from "memoize-one";

function getCountriesList(lang) {
  if (lang === "en") return englishCountries().getData();
  return frenchCountries.map((c) => ({ label: c, value: c }));
}
const memoizedCountriesList = memoizeOne(getCountriesList);

function valueOf(v) {
  if (!v) return "";
  if (typeof v === "object") return v.value;
  return v;
}

export default class CountrySelector extends PureComponent {
  handleChange = (name, value) => {
    const { onChange } = this.props;
    onChange(name, value);
  };

  expandValue = (value) => {
    const { lang } = this.props;
    if (!value) return value;
    const options = memoizedCountriesList(lang);
    return options.find((o) => o.value === valueOf(value));
  };

  render() {
    const { label, lang, name, value, placeholder, required } = this.props;
    return (
      <FieldContainer {...this.props}>
        <div className="af-country-select-container">
          <Select
            required={required}
            value={this.expandValue(value)}
            placeholder={placeholder || label}
            onChange={(data) => this.handleChange(name, data)}
            options={memoizedCountriesList(lang)}
          />
          {value && <input key={value} name={name} value={valueOf(value)} readOnly style={{ display: "none" }} />}
        </div>
      </FieldContainer>
    );
  }
}

CountrySelector.defaultProps = {
  lang: "en",
  label: "",
  placeholder: "",
  required: false,
};

CountrySelector.propTypes = {
  lang: PropTypes.oneOf(["fr", "en"]),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};
